module.exports = __webpack_public_path__ + "img/u8.0da5bfa4.png";